import { BrowserRouter, Route, Routes } from "react-router-dom";

import { AppLayout } from "../components/layout";
import { DemandNoPerspectivePage } from "./demand_no_perspective";
import { DemandPreviewPage } from "./demand_preview";
import { DemandWalkSinglePage } from "./demand_walk_single";
import { DemandPlanPage } from "./demand_plan";
import { ChatAssistantPage } from "./chat_assistant";
import { POExportNoPerspectivePage } from "./po_export_no_perspective";
import { ProfilePage } from "./profile";
import { RunHistoryPage } from "./run_history";
import { SupplyNoPerspectivePage } from "./supply_no_perspective";
import { SupplyWalkNoPerspectivePage } from "./supply_walk_no_perspective";
import { SupplyWalkSinglePage } from "./supply_walk_single";
import { SupplyWalkSingleForHubsPage } from "./supply_walk_single_for_hubs";
import ForecastTrackingPage from "./forecast_tracking";
import ThreeForecastTrackingPage from "./three_forecast_tracking";
import InventoryHealthPage from "./inventory_health";
import InventoryHealthMRPPage from "./inventory_health_mrp";
import InventoryHealthWithTransfersPage from "./inventory_health_with_transfers";
import InventoryHealthForHubsPage from "./inventory_health_for_hubs";
import InventoryWosCoraPage from "./inventory_wos_cora";
import TransferRecommendationsHubToSpokePage from "./transfer_recommendations_hub_to_spoke";
import RawInventoryHealthPage from "./raw_inventory_health";
import { TransferPlanningPage } from "./transfer_planning";
import { TransferRecommendationsPage } from "./transfer_recommendations";
import { InventoryNoPerspectivePage } from "./inventory";
import { AvantiCardRunsPage } from "./avanti_card_runs";
import { PurchaseOrderExportPeachAndLilyPage } from "./purchase_order_export_peach_and_lily";
import { PoInboxPage } from "./po_inbox";
import { MyTeamPage } from "./my_team";
import SkuCutoversPage from "./sku_cutovers";
import { PurchasingCalendarPage } from "./purchasing_calendar";
import { ContainerMappingPage } from "./container_mapping";
import { ManufacturerStockPage } from "./manufacturer_stock";
import { AuthCallbackComponent } from "../components/authentication/callback";
import { HelpArticlePage, HelpLibraryPage, HelpPublisherPage } from "./help";

export const AppRoutes = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<AppLayout />}>
          <Route index element={<RunHistoryPage />} />
          <Route index path="/run-history" element={<RunHistoryPage />} />

          <Route index path="/demand" element={<DemandNoPerspectivePage />} />
          <Route index path="/demand_preview" element={<DemandPreviewPage />} />

          <Route
            path="/demand-walk-single"
            element={<DemandWalkSinglePage />}
          />

          {/* Persistent forecast-editing module. Coexists with the Beta walk
              above (same "Demand Walk" menu label, distinct route). */}
          <Route path="/demand-plan" element={<DemandPlanPage />} />

          <Route index path="/supply" element={<SupplyNoPerspectivePage />} />

          <Route
            index
            path="/supply-walk"
            element={<SupplyWalkNoPerspectivePage />}
          />

          <Route
            index
            path="/supply-walk-single"
            element={<SupplyWalkSinglePage />}
          />

          <Route
            index
            path="/supply-walk-single-for-hubs"
            element={<SupplyWalkSingleForHubsPage />}
          />

          <Route path="/po-export" element={<POExportNoPerspectivePage />} />

          <Route index path="/chat" element={<ChatAssistantPage />} />
          <Route path="/profile" element={<ProfilePage />} />
          <Route
            index
            path="/forecast-tracking"
            element={<ForecastTrackingPage />}
          />
          <Route
            index
            path="/three-forecast-tracking"
            element={<ThreeForecastTrackingPage />}
          />
          <Route
            index
            path="/inventory-health"
            element={<InventoryHealthPage />}
          />
          <Route
            index
            path="/inventory-health-with-transfers"
            element={<InventoryHealthWithTransfersPage />}
          />
          <Route
            index
            path="/inventory-health-for-hubs"
            element={<InventoryHealthForHubsPage />}
          />
          <Route
            index
            path="/inventory-wos"
            element={<InventoryWosCoraPage />}
          />
          <Route
            index
            path="/transfer-recommendations-hub-to-spoke"
            element={<TransferRecommendationsHubToSpokePage />}
          />
          <Route
            index
            path="/inventory-health-mrp"
            element={<InventoryHealthMRPPage />}
          />
          <Route
            index
            path="/raw-inventory-health"
            element={<RawInventoryHealthPage />}
          />
          <Route
            index
            path="/inventory"
            element={<InventoryNoPerspectivePage />}
          />
          <Route
            index
            path="/transfer-planning"
            element={<TransferPlanningPage />}
          />
          <Route
            index
            path="/transfer-recommendations"
            element={<TransferRecommendationsPage />}
          />
          <Route
            index
            path="/avanti-card-runs"
            element={<AvantiCardRunsPage />}
          />
          <Route
            path="/purchase-order-export-peach-and-lily"
            element={<PurchaseOrderExportPeachAndLilyPage />}
          />
          <Route path="/po-inbox" element={<PoInboxPage />} />
          <Route path="/my-team" element={<MyTeamPage />} />
          <Route path="/sku-cutovers" element={<SkuCutoversPage />} />
          <Route
            path="/purchasing-calendar"
            element={<PurchasingCalendarPage />}
          />
          <Route path="/container-mapping" element={<ContainerMappingPage />} />
          <Route path="/help" element={<HelpLibraryPage />} />
          <Route path="/help/publish" element={<HelpPublisherPage />} />
          <Route path="/help/:slug" element={<HelpArticlePage />} />
          <Route
            path="/manufacturer-stock"
            element={<ManufacturerStockPage />}
          />
        </Route>

        {/* OAuth callback route - outside of AppLayout since user is not authenticated yet */}
        <Route path="/callback" element={<AuthCallbackComponent />} />
      </Routes>
    </BrowserRouter>
  );
};
